// src/utils/analytics.ts
// Todo lo que la web empuja al dataLayer. GTM recoge cada evento y lo manda a
// GA4; aqui no se habla con GA4 directamente (nunca gtag('event')). El
// consentimiento tampoco se toca desde el codigo: lo gestiona CookieConsent v3 desde GTM (cookie cc_cookie).
// Catalogo de eventos: PLA-SEO-GA-GEO.md (y seccion 4 del pla de les landings).

type Params = Record<string, string | number | boolean | undefined>;

/**
 * Todos los parametros que manda algun evento. GTM guarda en su modelo de datos
 * el ultimo valor de cada clave, asi que cada evento pone a `undefined` las que
 * no usa. Si un evento nuevo usa otra clave, se anade aqui y como variable en GTM.
 */
export const PARAM_KEYS = ['lang', 'mode', 'map', 'score', 'to', 'location'] as const;

export function track(event: string, params: Params = {}): void {
  const w = window as unknown as { dataLayer?: unknown[] };
  w.dataLayer = w.dataLayer || [];
  const reset = Object.fromEntries(PARAM_KEYS.map((key) => [key, undefined]));
  w.dataLayer.push({
    ...reset,
    lang: document.documentElement.lang || undefined,
    ...params,
    event,
  });
}

/** Dominios propios a los que se les da un nombre corto en `outbound_click`. */
const OUTBOUND_NAMES: Record<string, string> = {
  'vedratic.com': 'vedratic',
  'sindria.app': 'sindria',
  'momusa.tech': 'momusa',
  'keeplanding.com': 'keep',
};

export function outboundTarget(hostname: string): string {
  const host = hostname.replace(/^www\./, '');
  return OUTBOUND_NAMES[host] ?? host;
}

/** Desde donde sale el clic: `data-track-location`, footer, nav, id de la seccion o `page`. */
export function locationOf(el: Element): string {
  const explicit = el.closest<HTMLElement>('[data-track-location]')?.dataset.trackLocation;
  if (explicit) return explicit;
  if (el.closest('footer')) return 'footer';
  if (el.closest('header, nav')) return 'nav';
  return el.closest('section[id]')?.id.replace(/-/g, '_') || 'page';
}

/** Un solo listener delegado para los clics a enlaces de otro dominio. */
export function initAnalytics(): void {
  document.addEventListener('click', (event) => {
    const link = (event.target as Element | null)?.closest?.('a[href]') as HTMLAnchorElement | null;
    if (!link) return;
    let url: URL;
    try {
      url = new URL(link.href, location.href);
    } catch {
      return;
    }
    if (!/^https?:$/.test(url.protocol) || url.hostname === location.hostname) return;
    track('outbound_click', { to: outboundTarget(url.hostname), location: locationOf(link) });
  });
}
